/* global navigator */
import loadGoogleMapsApi from 'load-google-maps-api';
export default class Geolocation {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = {
      handleNoSupport: () => {},
      ...options
    };
    this.api = null;
  }
  loadApi() {
    return loadGoogleMapsApi({
      client: 'gme-coxenterprises',
      channel: 'atc-consumersite',
      v: '3'
    }).then(api => {
      this.api = api;
    });
  }
  extractZip(response) {
    const addressComponents = response[0].address_components;
    return addressComponents.filter(_ref => {
      let {
        types
      } = _ref;
      return types.includes('postal_code') && !types.includes('postal_code_suffix');
    })[0].long_name;
  }
  reverseGeoLookup(callback) {
    return response => {
      const {
        latitude,
        longitude
      } = response.coords;
      const location = new this.api.LatLng(latitude, longitude);
      const geocoder = new this.api.Geocoder();
      geocoder.geocode({
        location
      }, this.reverseGeoLookupSuccess(callback));
    };
  }
  reverseGeoLookupSuccess(callback) {
    return response => {
      callback({
        zipcode: this.extractZip(response),
        details: response
      });
    };
  }
  locate(onSuccess, onError) {
    if (navigator && navigator.geolocation) {
      return navigator.geolocation.getCurrentPosition(this.reverseGeoLookup(onSuccess), onError);
    }
    return this.options.handleNoSupport();
  }
}